module.exports = __webpack_public_path__ + "img/78f221e.jpg";